import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-blank-page',
    template: '<!-- blank page -->'
})
export class BlankPageComponent implements OnInit {

    constructor() {
    }

    ngOnInit(): void {
    }

}
